import React from "react";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-row">
            <div className="auth-logo">KLC</div>
            <h1 className="auth-title">Reset Password</h1>
          </div>
          <p className="auth-subtitle">This will be wired to backend later.</p>
        </div>

        <div className="card" style={{ boxShadow: "none", padding: 0 }}>
          <p className="help-text">
            Placeholder page. When you share the API, we’ll add form + OTP/email flow here.
          </p>

          <Link to="/login" className="btn btn-outline">
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}

